import React from 'react';
import { Settings, Eye, LogOut } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';
import { useEditMode } from '../hooks/useEditMode';
import LoginModal from './LoginModal';

const SettingsButton = () => {
  const { isAuthenticated, isAdmin, signOut } = useAuth();
  const { isEditMode, toggleEditMode } = useEditMode();
  const [isLoginModalOpen, setIsLoginModalOpen] = React.useState(false);

  const handleClick = () => {
    if (isAuthenticated) {
      if (window.confirm('Voulez-vous vous déconnecter ?')) {
        signOut();
      }
    } else {
      setIsLoginModalOpen(true);
    }
  };

  return (
    <>
      <div className="fixed bottom-4 left-4 z-50 flex items-center gap-3">
        <button
          onClick={handleClick}
          className={`p-3 rounded-full transition-all duration-200 backdrop-blur-sm ${
            isAuthenticated && isAdmin
              ? 'bg-dark text-beige hover:bg-dark/90'
              : 'bg-dark/5 hover:bg-dark/10'
          }`}
          title={isAuthenticated ? "Se déconnecter" : "Se connecter"}
        >
          {isAuthenticated ? (
            <LogOut className="h-5 w-5" />
          ) : (
            <Settings className="h-5 w-5 text-dark/60" />
          )}
        </button>

        {isAuthenticated && isAdmin && (
          <>
            <button
              onClick={toggleEditMode}
              className={`p-3 rounded-full transition-all duration-200 backdrop-blur-sm ${
                isEditMode 
                  ? 'bg-dark text-beige hover:bg-dark/90' 
                  : 'bg-dark/5 hover:bg-dark/10'
              }`}
              title={isEditMode ? "Mode lecture" : "Mode édition"}
            >
              <Eye className="h-5 w-5" />
            </button>

            <div className="bg-dark/5 backdrop-blur-sm text-dark/60 py-2 px-4 rounded-full text-sm flex items-center gap-2">
              {isEditMode ? 'Mode édition actif' : 'Mode lecture'}
            </div>
          </>
        )}
      </div>

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
      />
    </>
  );
};

export default SettingsButton;